import { ActionReducerMap, createFeatureSelector } from '@ngrx/store'

import { ScopeConfigurationState } from '@app/features/scope-overview/model/scope-configuration/scope-configuration.state.model'
import { ScopeOverviewState } from '@app/features/scope-overview/model/scope-overview.state.model'
import { scopeConfigurationReducer } from './scope-configuration.reducer'
import { scopeOverviewReducer } from './scope-overview.reducer'
import { ChangeRequestState } from '../../change-request/model/change-request.state.model'
import { changeRequestReducer } from '../../change-request/store/reducers/change-request.reducer'

export const featureKey = 'scope-overview'

export interface State {
  scopeOverview: ScopeOverviewState
  scopeConfiguration: ScopeConfigurationState
  changeRequest: ChangeRequestState
}

export const reducers: ActionReducerMap<State> = {
  scopeOverview: scopeOverviewReducer,
  scopeConfiguration: scopeConfigurationReducer,
  changeRequest: changeRequestReducer,
}

export const getScopeOverviewState = createFeatureSelector<State>('scope-overview')
export const getScopeConfigurationState = createFeatureSelector<State>('scope-configuration')
export const getChangeRequestState = createFeatureSelector<ChangeRequestState>('change-request')
